import { Header, Footer } from "@/components/Layout";
import { useAuth } from "@/context/AuthContext";
import { 
  HeroSection, 
  HowItWorksSection, 
  PricingPreviewSection, 
  TrustSection, 
  CTASection 
} from "@/components/LandingSections";

const LandingPage = () => {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Header />
      <HeroSection user={user} />
      <HowItWorksSection />
      <PricingPreviewSection user={user} />
      <TrustSection />
      <CTASection user={user} />
      <Footer />
    </div>
  );
};

export default LandingPage;
